var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tr',[(_vm.hasHeaderSlot)?_c('b-td',[_vm._t("rowHeader",null,null,_vm.model)],2):_vm._e(),_vm._l((_vm.fields),function(field){return _c('b-td',{key:field.key},[(field.key === 'Inventory')?[_c('modal-inventory',{attrs:{"item":_vm.model}})]:[_vm._v(" "+_vm._s(_vm.displayValue(field))+" ")]],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }